import { Injectable } from "@angular/core";
@Injectable()
export class CacheService {
    private isCacheEnabled = {
        //key : value pair
    }
    // Set true to enable cache and false to disable cache
    public setCachingStatus(key, value = true) {
        this.isCacheEnabled[key] = value;
    }
    public getCachingStatus(key) {
        return this.isCacheEnabled[key];
    }
    // Set all caches value to false.
    public clearCache() {
        Object.keys(this.isCacheEnabled).forEach((key) => this.isCacheEnabled[key] = false)
    }
}
